import { Alert, AlertTitle, styled } from '@mui/material'

export const StyledAlert = styled(Alert, {
  shouldForwardProp: (prop) => prop !== 'showOnClick' && prop !== 'titlePadding',
})<{ showOnClick: boolean; titlePadding?: boolean }>`
  cursor: ${({ showOnClick }) => (showOnClick ? 'pointer' : 'auto')};
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
  box-sizing: border-box;

  & .MuiAlert-message {
    display: flex;
    flex-direction: column;

    gap: ${({ theme, titlePadding }) => theme.spacing(titlePadding ? 2 : 0)};
    width: 100%;
    padding: 0;
  }
`

export const StyledTitle = styled(AlertTitle)`
  margin: 0;
`
